<tec-modal
    [isVisible]="isVisible"
    [title]="'OPERATIONS.DETAIL.IRPF_MODAL_TITLE' | translate"
    (closeEvent)="close()"
>
    <ng-container body>
        @if (hasMismatch() || status === OPERATION_STATUS.KO) {
            <tec-alert
                status="warning"
                [msg]="'OPERATIONS.DETAIL.IRPF_MODAL_ALERT' | translate"
                [hiddenCloseButton]="true"
            />
        }
        @if (rows().length) {
            <tec-table
                [headers]="[
                    { label: ('OPERATIONS.DETAIL.IRPF_MODAL_COL_TYPE' | translate) },
                    { label: ('OPERATIONS.DETAIL.IRPF_MODAL_COL_DOCUMENT' | translate) },
                    { label: ('OPERATIONS.DETAIL.IRPF_MODAL_COL_DATA' | translate) },
                ]"
                [rows]="rows()"
                [config]="{ clickeable: false, borderless: true }"
            />
        }
    </ng-container>
</tec-modal>
